var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99999 5.99951V8.66618M7.99999 11.3328H8.00665M14.4869 11.9997L9.1536 2.66633C9.03731 2.46113 8.86867 2.29046 8.66488 2.17171C8.46109 2.05296 8.22946 1.9904 7.9936 1.9904C7.75774 1.9904 7.5261 2.05296 7.32231 2.17171C7.11853 2.29046 6.94989 2.46113 6.8336 2.66633L1.50026 11.9997C1.38272 12.2032 1.32108 12.4343 1.3216 12.6693C1.32212 12.9044 1.38478 13.1352 1.50323 13.3382C1.62167 13.5413 1.7917 13.7094 1.99606 13.8256C2.20043 13.9417 2.43187 14.0018 2.66693 13.9997H13.3336C13.5675 13.9994 13.7973 13.9376 13.9998 13.8205C14.2023 13.7034 14.3704 13.5351 14.4873 13.3324C14.6041 13.1298 14.6656 12.8999 14.6656 12.666C14.6655 12.4321 14.6039 12.2023 14.4869 11.9997Z",
    stroke: "#EF4444",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.d4bf6e7edc8af42d64e7b6cbeeeb67c9.svg";
export { ForwardRef as ReactComponent };